import { createContext, useContext, useMemo, type ReactNode } from 'react';

import { useSidebar } from '@hooks/useSidebar';

interface SidebarApi {
  collapsed: boolean;
  toggle: () => void;
  setCollapsed: (collapsed: boolean) => void;
  mobileOpen: boolean;
  openMobile: () => void;
  closeMobile: () => void;
}

const SidebarContext = createContext<SidebarApi | null>(null);

export function SidebarProvider({ children }: { children: ReactNode }) {
  const { collapsed, toggle, setCollapsed, mobileOpen, openMobile, closeMobile } = useSidebar();
  const value = useMemo(
    () => ({ collapsed, toggle, setCollapsed, mobileOpen, openMobile, closeMobile }),
    [collapsed, toggle, setCollapsed, mobileOpen, openMobile, closeMobile],
  );
  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>;
}

export function useSidebarContext(): SidebarApi {
  const ctx = useContext(SidebarContext);
  if (!ctx) throw new Error('useSidebarContext must be used within a <SidebarProvider />');
  return ctx;
}
